module.exports = __webpack_public_path__ + "static/media/img19_LV.5b0840ca.png";